import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import * as moment from 'moment';

import { ActivatedRoute, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { AuthPageManageService } from '../manage/page-manage/auth-page-manage.service';
import { PanierService } from "../manage/panier/panier.service";
import { SalemethodService } from "../api/salemethod/salemethod.service";


@Injectable({
  providedIn: 'root'
})

export class ToolsService {
  public static TAG_MERCHANT_STORAGE: string = "id_merchant"

  // Loader
  private loader: BehaviorSubject<boolean> = new BehaviorSubject(false);

  get getLoader(): Observable<boolean> {
    return this.loader.asObservable();
  }

  // After client registered
  private statusMessage: BehaviorSubject<any> = new BehaviorSubject(null);

  // Side data backoffice client
  private sideData: BehaviorSubject<any> = new BehaviorSubject(null);

  // Current page client
  private pageClient: BehaviorSubject<any> = new BehaviorSubject(null);

  // Current remove panier
  public removePanier: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);

  get getRemovePanier(): Observable<boolean | null> {
    return this.removePanier.asObservable();
  }

  get getStatusMessage(): Observable<string> {
    return this.statusMessage.asObservable();
  }

  get getPageClient(): Observable<string> {
    return this.pageClient.asObservable();
  }

  get getSideData(): Observable<any> {
    return this.sideData.asObservable();
  }


  //onPopState
  private onPopState: any = null;


  // set Favicone
  private favicone: BehaviorSubject<any> = new BehaviorSubject(null);


  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private snackBar: MatSnackBar,
    private router: Router,
    private AuthPageManageService: AuthPageManageService,
  ) {
  }

  // FORMS

  resetForm(fd: FormGroupDirective, fg: FormGroup) {
    fd.resetForm();
    fg.reset();
  }

  fieldRequired(form: FormGroup, field: string): any {
    let thisField = form.controls[field];
    if (thisField.errors) {
      if (thisField.errors['required']) {
        return true;
      }
    }
  }

  // LOADER

  start() {
    this.loader.next(true);
  }

  end() {
    this.loader.next(false);
  }

  // SCROLL

  autoScrollBot(where: string) {

    setTimeout(() => {
      const objDiv: any = document.getElementById(where);
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight;
      }
    });
  }

  scrollTo(where: string) {

    const el: any = document.getElementById(where);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
    }
    ;
  }

  // Affectation d'une variable en session storage
  setStor(key: string, val: any) {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(key, JSON.stringify(val));
    }
  }

  // Récupération d'une variable en session storage
  getStor(key: string): any {
    if (isPlatformBrowser(this.platformId)) {
      let stor = !sessionStorage.getItem(key) || sessionStorage.getItem(key) == "undefined" ? null : sessionStorage.getItem(key);
      if (stor) {
        stor = JSON.parse(stor);
      }
      return stor;
    }
  }

  // Suppression d'une variable en session storage
  removeStor(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem(key);
    }
  }

  // Pirge session storage
  clearStor() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.clear();
    }
  }

  // STATUS MESSAGE
  setStatusMessage(from: any) {
    this.statusMessage.next(from);
  }

  removeStatusMessage() {
    this.statusMessage.next(null);
  }

  // Check if is empty object
  isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0 ? true : false;
  }

  // SNACKBAR

  openSnackBar(message: string, classNames: any, duration?: number | any, verticalPosition?: any) {
    let arrayClasses = ["text-center"];
    Array.isArray(classNames) ? arrayClasses = arrayClasses.concat(classNames) : arrayClasses.push(classNames);
    let myConf: MatSnackBarConfig = {
      duration: (duration ? duration : 1000),
      panelClass: arrayClasses,
      verticalPosition: (verticalPosition ? verticalPosition : "top"),
      horizontalPosition: "center"
    }
    this.snackBar.open(message, "", myConf);
  }

  getSnackBar() {
    return this.snackBar;
  }

  closeSnackBar() {
    this.snackBar.dismiss();
  }

  // EXPIRY
  checkAndSetExpiryDate() {

    const expiryDate: any = this.getStor("expiry_date");
    const now: any = moment();

    let url = this.getStor("url_encode");
    let id_merchant = this.getStor("id_merchant");

    let devicePaybridge = this.getStor("devicePaybridge") ? this.getStor("devicePaybridge") : null;
    let devicePrintAuto = devicePaybridge && this.getStor("devicePaybridgePrint") ? this.getStor("devicePaybridge") : null;


    if (!expiryDate || (expiryDate && now.isSameOrAfter(moment(expiryDate)))) {


      this.clearStor();

      if (url) {
        this.setStor("url_encode", url);
      }
      if (id_merchant) {
        this.setStor("id_merchant", id_merchant);
      }

      if (devicePaybridge) {
        this.setStor("devicePaybridge", devicePaybridge);
        this.setStor("devicePaybridgePrint", devicePrintAuto);
      }


    }

    this.setStor("expiry_date", now.add(12, 'hours'));
  }

  checkExpiryDatebeforePay() {


    // const expiryDate=  "2023-11-09T01:54:19.999Z";
    const expiryDate: any = this.getStor("expiry_date");
    const now: any = moment();


    let result = null;

    if (expiryDate && now.isSameOrAfter(moment(expiryDate))) {
      result = "depassé";
      //on ajoute du temps
      this.setStor("expiry_date", now.add(12, 'hours'));
      //  ouverture du popup avec redirection
      this.removePanier.next(true);
      this.removeStor(PanierService.TAG_STORAGE);
    }
    // //evite de se reouvrir
    // this.removePanier.next(false);

    return result;


  }

  setExpirity() {
    const now: any = moment();
    this.setStor("expiry_date", now.add(12, 'hours'));
  }


  // SIDE DATA CLIENT

  // {type:'example', data: data}
  setSideData(dataObject: any) {
    this.sideData.next(dataObject);
  }


  // Selected page client
  setPageClient(pageName: string) {
    this.pageClient.next(pageName);
  }

  // popstate est un événement JavaScript qui se déclenche lorsque l'entrée active de l'historique de la session change.
  // par exemple, quand l'utilisateur clique sur le bouton "Retour" ou "Suivant" du navigateur. Cette méthode est utilisée
  // pour activer ou réactiver la gestion des événements popstate après la fermeture d'une pop-up.
  // Il est parfois nécessaire de désactiver temporairement les événements popstate pendant l'ouverture de modales pour éviter
  // des comportements inattendus lors de la navigation, et il faut penser à les réactiver après leur fermeture.
  // C'est le cas des paiements Stripe par exemple.
  setOnPopState(state?: any, currSmId?: any, openCheckAddress?: any) {
    let result = {
      state: state,
      currSmId: currSmId,
      openCheckAddress: openCheckAddress
    }
    this.onPopState = result;
  }

  getOnPopState() {
    return this.onPopState;
  }

  checkCurrentPage(value: string) {
    const splitedUrl = this.router.url.split("/");
    const urlName = splitedUrl[1];
    let flag = false;
    if (value.toLowerCase() === "product") {
      flag = (urlName === "product" || urlName === "s") ? true : false;
    } else if (value.toLowerCase() === "pointofsale") {
      flag = (urlName === "pointofsale" || urlName === "p") ? true : false;
    } else {
      flag = this.router.url.includes(value.toLowerCase());
    }
    return flag;
  }

  goRedirectPage(pageName: string,) {
    if (pageName === "product") {
      this.goProductPage();
    } else if (pageName === "pointofsale") {
      this.goPointOfSalePage();
    } else {
      this.router.navigate(["/" + pageName]);
    }
  }


  goPointOfSalePage() {

    const endurl = this.getStor("url_encode") ? this.getStor("url_encode") : null;
    const id_merchant = this.getStor("id_merchant") ? this.getStor("id_merchant") : null;


    let url = "/p";

    if (endurl && id_merchant) {
      url += "/" + endurl + "/" + id_merchant;
    }


    this.router.navigate([url]);


  }

  goProductPage(pointOfSale?: any, currSM?: any, smId?: any, modeBorne?: any) {
    // console.log("tools.service - goProductPage - pointOfSale : ", pointOfSale);
    // console.log("tools.service - goProductPage - currSM : ", currSM);
    // console.log("tools.service - goProductPage - smId : ", smId);
    // console.log("tools.service - goProductPage - modeBorne : ", modeBorne);
    const currPos = pointOfSale ? pointOfSale : this.getStor("point_of_sale");
    // console.log("tools.service - goProductPage - currPos : ", currPos);

    if (currPos) {
      let url = "/s/" + currPos.url_encode + "/" + currPos.idWebshop;
      // console.log("tools.service - goProductPage - url : ", url);
      //header currSM
      let currentSalemethod = currSM ? currSM : this.getStor(SalemethodService.TAG_STORAGE) ? this.getStor(SalemethodService.TAG_STORAGE) : null;
      // console.log("tools.service - goProductPage - currentSalemethod : ", currentSalemethod);
      //en url  url salemethod ou infonote et value ou rien
      let endUrl = null;

      //salemethod url
      if (this.getStor("smId")) {
        endUrl = "/" + this.getStor("smId");
      }
      // console.log("tools.service - goProductPage - endUrl : ", endUrl);

      //info dans url
      if (currentSalemethod && currentSalemethod.disable_authentification_info_notes) {
        // console.log("tools.service - goProductPage - currentSalemethod : ", currentSalemethod);
        endUrl = "/" + currentSalemethod.id + "/" + currentSalemethod.disable_authentification_info_notes.id + "/" + currentSalemethod.disable_authentification_info_notes.value;
      }

      if (endUrl) {
        url += endUrl;
      }
      // console.log("tools.service - goProductPage - url : ", url);
      this.router.navigate([url]);
    } else if (this.getStor("id_merchant")) {
      this.goPointOfSalePage();
    }
  }

  /**
   * @param {string} url
   * @param {boolean} isBlank Ouvre un nouvel onglet ou non
   * @description Redirige vers l'url renseigné (Url externe à l'application)
   * @return {void}
   */
  goUrl(url: string, isBlank: boolean): void {
    url = (url.indexOf('://') === -1) ? 'http://' + url : url;
    isBlank ?
      window.open(url, '_blank') :
      window.open(url);
  }


  goHome() {
    window.location.href = window.location.origin;
  }

  goHome_() {

    this.AuthPageManageService.setCurrPage("register");
    let url = 'auth/home';
    this.router.navigate([url]);

  }


  // favicone

  setFavicone(data?: any) {
    this.favicone.next(data ? data : null);
  }

  getFavicone(): Observable<any> {
    return this.favicone.asObservable();
  }

}

